import { useState } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import { Menu, X, Phone, MessageCircle, ArrowUpRight, Facebook, Youtube, Instagram, Twitter, Linkedin, AtSign, Pin } from "lucide-react";
import { BRAND, SOCIALS, waLink } from "@/data/content";
import ChatWidget from "@/components/ChatWidget";

const SOCIAL_ICONS = { Facebook, YouTube: Youtube, Instagram, WhatsApp: MessageCircle, Threads: AtSign, Pinterest: Pin, "X (Twitter)": Twitter, LinkedIn: Linkedin };

const NAV = [
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/partner", label: "Partner" },
  { to: "/connect", label: "My Platforms" },
  { to: "/contact", label: "Contact" },
];

export default function Layout() {
  const [open, setOpen] = useState(false);
  return (
    <div className="site">
      <div className="topline">
        <span>{BRAND.tagline}</span>
        <span>Bindki • Fatehpur • Uttar Pradesh</span>
      </div>
      <header className="nav" data-testid="main-navigation">
        <Link to="/" className="brand" data-testid="brand-home-link" onClick={() => setOpen(false)}>
          <span className="brand-mark">BB</span>
          <span className="brand-text"><strong>BIMA BACHAT</strong><small>BAZAR</small></span>
        </Link>
        <nav className="nav-links" data-testid="primary-links">
          {NAV.map((item) => (
            <NavLink key={item.to} to={item.to} data-testid={`nav-${item.label.toLowerCase().replaceAll(" ", "-")}-link`} className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="nav-actions">
          <a href={waLink()} target="_blank" rel="noopener noreferrer" className="btn btn-whatsapp btn-sm" data-testid="nav-whatsapp-cta">
            <MessageCircle size={15} /> WhatsApp
          </a>
          <a href={`tel:+91${BRAND.phone1}`} className="btn btn-primary btn-sm" data-testid="nav-call-cta">
            <Phone size={15} /> Call Now
          </a>
          <button className="mobile-menu-btn" onClick={() => setOpen(!open)} data-testid="mobile-menu-button" aria-label="Menu">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </header>
      {open && (
        <div className="mobile-drawer" data-testid="mobile-drawer">
          {NAV.map((item) => (
            <Link key={item.to} to={item.to} onClick={() => setOpen(false)} data-testid={`mobile-nav-${item.label.toLowerCase().replaceAll(" ", "-")}`}>
              {item.label} <ArrowUpRight size={16} />
            </Link>
          ))}
          <Link to="/admin" onClick={() => setOpen(false)} data-testid="mobile-nav-advisor">Advisor Login <ArrowUpRight size={16} /></Link>
        </div>
      )}
      <main><Outlet /></main>
      <footer className="footer" data-testid="site-footer">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="brand">
              <span className="brand-mark">BB</span>
              <span className="brand-text"><strong>BIMA BACHAT</strong><small>BAZAR</small></span>
            </div>
            <p>{BRAND.tagline}. Insurance, investment, tax aur digital services — aapke apne Bindki mein.</p>
            <div className="footer-social" data-testid="footer-social-links">
              {SOCIALS.map((s) => {
                const Icon = SOCIAL_ICONS[s.name] || ArrowUpRight;
                return (
                  <a key={s.name} href={s.url} target="_blank" rel="noopener noreferrer" aria-label={s.name} title={s.name} data-testid={`footer-social-${s.name.toLowerCase().replaceAll(/[^a-z0-9]+/g, "-")}`}>
                    <Icon size={17} />
                  </a>
                );
              })}
            </div>
          </div>
          <div className="footer-col">
            <strong>Services</strong>
            <Link to="/services/insurance" data-testid="footer-insurance-link">Insurance</Link>
            <Link to="/services/investment-mutual-funds" data-testid="footer-investment-link">Investment & Mutual Funds</Link>
            <Link to="/services/tax-gst" data-testid="footer-tax-link">Tax & GST</Link>
            <Link to="/services/banking-csc" data-testid="footer-csc-link">Banking & CSC</Link>
          </div>
          <div className="footer-col">
            <strong>Company</strong>
            <Link to="/about" data-testid="footer-about-link">About Utkarsh Gupta</Link>
            <Link to="/partner" data-testid="footer-partner-link">Become a Partner</Link>
            <Link to="/connect" data-testid="footer-connect-link">My Platforms</Link>
            <Link to="/contact" data-testid="footer-contact-link">Contact</Link>
            <Link to="/admin" data-testid="advisor-dashboard-link">Advisor Login</Link>
          </div>
          <div className="footer-col">
            <strong>Legal</strong>
            <Link to="/privacy-policy" data-testid="privacy-policy-link">Privacy Policy</Link>
            <Link to="/terms" data-testid="terms-link">Terms & Conditions</Link>
            <Link to="/disclaimer" data-testid="disclaimer-link">Investment Disclaimer</Link>
          </div>
          <div className="footer-col footer-contact">
            <strong>Visit / Call</strong>
            <span>{BRAND.address}</span>
            <a href={`tel:+91${BRAND.phone1}`} data-testid="footer-phone-link">{BRAND.phone1}</a>
            <a href={`tel:+91${BRAND.phone2}`} data-testid="footer-second-phone-link">{BRAND.phone2}</a>
            <a href={`mailto:${BRAND.email}`} data-testid="footer-email-link">{BRAND.email}</a>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© 2026 Bima Bachat Bazar. All rights reserved.</span>
          <span>Market-linked investments are subject to market risks.</span>
        </div>
      </footer>
      <div className="sticky-cta" data-testid="sticky-cta-bar">
        <a href={waLink()} target="_blank" rel="noopener noreferrer" className="sticky-whatsapp" data-testid="sticky-whatsapp-button">
          <MessageCircle size={18} /> WhatsApp Consultation
        </a>
        <a href={`tel:+91${BRAND.phone1}`} className="sticky-call" data-testid="sticky-call-button">
          <Phone size={18} /> Call Now
        </a>
      </div>
      <ChatWidget />
    </div>
  );
}
